/* eslint-disable */
axios.defaults.baseURL = '';
axios.defaults.timeout = 5 * 60 * 1000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.withCredentials = true;